
import { useState } from "react"
import { Container, Row, Col, Form, FormGroup, Label, Input, Button } from "reactstrap"
import { MapPin } from "lucide-react"
import UpdateForm from "../pages/UpdateForm"

export default function AddBranch({update}) {
  const [formData, setFormData] = useState({
    branchName: "",
    managerName: "",
    email: "",
    phone: "",
    location: "",
  })

  const [loading, setLoading] = useState(false)

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    setTimeout(() => {
      console.log("Branch Data:", formData)
      alert("Branch added successfully!")
      // Reset form
      setFormData({
        branchName: "",
        managerName: "",
        email: "",
        phone: "",
        location: "",
      })
      setLoading(false)
    }, 1500)
  }

  const handleCancel = () => {
    setFormData({
      branchName: "",
      managerName: "",
      email: "",
      phone: "",
      location: "",
    })
  }

  return (
  
      <Container>
        <Row className="justify-content-center">
          <Col lg="8" md="10" xs="12">
            {/* Header Section */}
            <div className="mb-8">
              {UpdateForm?(<h1 className="text-4xl font-bold text-black mb-2">Update Branch</h1>):(<h1 className="text-4xl font-bold text-black mb-2">Add Branch</h1>)}
              <p className="text-black text-lg">
                Fill in the details below to add a new branch to your organization
              </p>
            </div>

            {/* Main Form Card */}
            <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
              <Form onSubmit={handleSubmit}>
                {/* Branch Info Icon Section */}
                <div className="mb-4 pb-4 border-b border-gray-200">
                  <div className="d-flex gap-3 align-items-center ">
                    <div
                      className="bg-gray-100 rounded-lg p-3 d-flex align-items-center justify-content-center"
                      style={{ width: "50px", height: "50px" }}
                    >
                      <MapPin size={24} className="text-black" />
                    </div>
                    <div >
                      <p className="text-black font-semibold mb-0">Branch Location</p>
                      <p className="text-black text-sm mb-0">Manage your branch information</p>
                    </div>
                  </div>
                </div>

                {/* Branch Name Row */}
                <Row className="mb-5">
                  <Col md="12">
                    <FormGroup>
                      <Label for="branchName" className="text-black font-semibold mb-2">
                        Branch Name <span className="text-red-500">*</span>
                      </Label>
                      <Input
                        type="text"
                        name="branchName"
                        id="branchName"
                        placeholder="Enter branch name "
                        value={formData.branchName}
                        onChange={handleInputChange}
                        required
                        className="border-gray-300 py-2 px-3"
                        style={{ borderColor: "#e5e7eb" }}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                {/* Manager Name and Email Row */}
                <Row className="mb-5">
                  <Col md="6" className="mb-4 mb-md-0">
                    <FormGroup>
                      <Label for="managerName" className="text-black font-semibold mb-2">
                        Manager Name <span className="text-red-500">*</span>
                      </Label>
                      <Input
                        type="text"
                        name="managerName"
                        id="managerName"
                        placeholder="Enter manager full name"
                        value={formData.managerName}
                        onChange={handleInputChange}
                        required
                        className="border-gray-300 py-2 px-3"
                        style={{ borderColor: "#e5e7eb" }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label for="email" className="text-black font-semibold mb-2">
                        Email <span className="text-red-500">*</span>
                      </Label>
                      <Input
                        type="email"
                        name="email"
                        id="email"
                        placeholder="Enter email address"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        className="border-gray-300 py-2 px-3"
                        style={{ borderColor: "#e5e7eb" }}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                {/* Phone and Location Row */}
                <Row className="mb-5">
                  <Col md="6" className="mb-4 mb-md-0">
                    <FormGroup>
                      <Label for="phone" className="text-black font-semibold mb-2">
                        Phone <span className="text-red-500">*</span>
                      </Label>
                      <Input
                        type="tel"
                        name="phone"
                        id="phone"
                        placeholder="+977"
                        value={formData.phone}
                        onChange={handleInputChange}
                        required
                        className="border-gray-300 py-2 px-3"
                        style={{ borderColor: "#e5e7eb" }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label for="location" className="text-black font-semibold mb-2">
                        Location <span className="text-red-500">*</span>
                      </Label>
                      <Input
                        type="text"
                        name="location"
                        id="location"
                        placeholder="Enter city, state or full address"
                        value={formData.location}
                        onChange={handleInputChange}
                        required
                        className="border-gray-300 py-2 px-3"
                        style={{ borderColor: "#e5e7eb" }}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                {/* Action Buttons */}
                <div className="d-flex gap-3 justify-content-end pt-6 border-t border-gray-200">
                  <Button
                    type="button"
                    color="light"
                    className="px-6 py-2 font-semibold text-black border border-gray-300"
                    onClick={handleCancel}
                    disabled={loading}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    color="dark"
                    className="px-6 py-2 font-semibold bg-black text-white"
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </Button>
                </div>
              </Form>
            </div>

            {/* Footer Info */}
            <div className="mt-6 text-center text-gray-500 text-sm">
              <p>
                All fields marked with <span className="text-red-500">*</span> are required
              </p>
            </div>
          </Col>
        </Row>
      </Container>

  )
}
